<template>
  <v-list three-line>
    <v-list-item
      v-ripple
      to="/marrySubsidy/applyForm"
    >
      <v-list-item-content>
        <v-list-item-title>{{ $t('Subsidy.MarriageSubsidy') }}</v-list-item-title>
        <!-- <v-list-item-sub-title>
            {{ item.pcDetail.chinDisplayDateTime }}
            <span v-if="item.pcDetail.chinRegion"> - {{ item.pcDetail.chinRegion }}</span>
          </v-list-item-sub-title> -->
        <v-list-item-subtitle>{{ $t('Subsidy.Marriage.Subtitle') }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <v-list-item
      v-ripple
      to="/bornSubsidy/applyForm"
    >
      <v-list-item-content>
        <v-list-item-title>{{ $t('Subsidy.BornSubsidy') }}</v-list-item-title>
        <!-- <v-list-item-sub-title>
            {{ item.pcDetail.chinDisplayDateTime }}
            <span v-if="item.pcDetail.chinRegion"> - {{ item.pcDetail.chinRegion }}</span>
          </v-list-item-sub-title> -->
        <v-list-item-subtitle>{{ $t('Subsidy.Born.Subtitle') }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<style scoped>
  .v-avatar {
    height: auto !important;
  }

  .v-avatar .v-image {
    border-radius: 10%;
  }
</style>

<script>

export default {
  components: {
  },
  data: () => {
    return {

    }
  }
}
</script>
